import { useState } from "preact/hooks";
import { lang, useT } from "./i18n";
import { Account, cancelSubscription, linkToBuy, linkToBuyDays } from "./xsolla";
import { reachGoal } from "./ym";

const cancelSubscriptionPage: { [lang: string]: string } = {
    en: "https://v8.js-dos.com/cancel-your-subscription/",
    ru: "https://v8.js-dos.com/ru/cancel-your-subscription/",
};

const newPageTarget = "_self";

export function PremiumPlan(props: { account: Account, subscription: string }) {
    const t = useT();
    const { account, subscription } = props;
    const [locked, setLocked] = useState<boolean>(false);
    const [busy, setBusy] = useState<boolean>(false);

    const token = account.token.access_token;
    function onBuy() {
        if (locked || busy) {
            return;
        }

        setBusy(true);
        reachGoal("buy-click");

        linkToBuy(token)
            .then((link) => {
                if (link !== null) {
                    reachGoal("buy");
                    // alert(t("please_reload_on_success"));
                    window.open(link, newPageTarget);
                    setLocked(true);
                    document.addEventListener("visibilitychange", () => {
                        if (!document.hidden) {
                            location.reload();
                        }
                    });
                }
            })
            .catch(console.error)
            .finally(() => setBusy(false));
    }

    async function cancel() {
        const openPage = () => {
            alert(t("unable_to_cancel_subscription"));
            window.open(cancelSubscriptionPage[lang] ?? cancelSubscriptionPage.en, newPageTarget);
        };
        if (!account) {
            openPage();
        } else {
            try {
                if (await cancelSubscription(account.token.access_token, subscription)) {
                    reachGoal("cancel");
                    alert(t("subscription_cancelled"));
                } else {
                    openPage();
                }
            } catch (e) {
                openPage();
            }
        }
    }

    return <div class={"premium-plan-root " + (subscription.length > 0 ? "have-premium" : "") + " min-w-80"}>
        <div class="premium-plan-head flex">
            {subscription.length > 0 && <PremiumCheck />}
            <div class="cursor-pointer underline" onClick={openPremiumPage}>{t("premium")}</div>
            <div class="flex-grow"></div>
            {subscription.length > 0 &&
                <button
                    onClick={cancel}
                    class="ml-2 btn btn-xs text-success-content">
                    {t("cancel")}
                </button>}
        </div>
        {subscription.length === 0 &&
            <>
                <div class="flex flex-row my-6 items-top">
                    <div class="premium-plan-cost">
                        1$
                    </div>
                    <div class="premium-plan-cost-expl">
                        <div>USD / month</div>
                        <div><span class="text-blue-600">7</span> {t("try_free")}</div>
                    </div>
                </div>
                {!locked && !busy && <button class="btn btn-primary w-full" onClick={onBuy}>
                    {t("buy")}
                </button>}
                {(busy || locked) && <button class="btn btn-primary w-full" disabled>
                    {t("loading")}
                </button>}
            </>
        }
    </div>;
}

export function PremiumDays(props: { account: Account, price: number,
    description: string, title: string, sku: "pass30" | "pass180" }) {
    const t = useT();
    const { account, price, description, title, sku } = props;
    const [busy, setBusy] = useState<boolean>(false);
    const [locked, setLocked] = useState<boolean>(false);

    const token = account.token.access_token;
    function onBuy() {
        if (locked || busy) {
            return;
        }

        setBusy(true);

        reachGoal("buy-click");
        linkToBuyDays(token, sku)
            .then((link) => {
                if (link !== null) {
                    reachGoal("buy");
                    // alert(t("please_reload_on_success"));
                    window.open(link, newPageTarget);
                    setLocked(true);
                    document.addEventListener("visibilitychange", () => {
                        if (!document.hidden) {
                            location.reload();
                        }
                    });
                }
            })
            .catch(console.error)
            .finally(() => setBusy(false));
    }

    return <div class="premium-plan-root min-w-80 single-payment">
        <div class="premium-plan-head flex">
            <div class="cursor-pointer underline" onClick={openPremiumPage}>{t(title)}</div>
            <div class="flex-grow"></div>
        </div>
        <div class="flex flex-row my-6 items-top">
            <div class="premium-plan-cost">
                {price}$
            </div>
            <div class="premium-plan-cost-expl">
                <div>USD / {description}</div>
                <div>{t("single_payment")}</div>
            </div>
        </div>
        {!locked && !busy && <button class="btn btn-primary w-full " onClick={onBuy}>
            {t("buy")}
        </button>}
        {(busy || locked) && <button class="btn btn-primary w-full" disabled>
            {t("loading")}
        </button>}
    </div>;
}

function openPremiumPage() {
    window.open("https://js-dos.com/cloud-overview.html", "_blank");
}

export function PremiumCheck() {
    return <svg xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="mr-4 w-6 h-6 text-blue-500 flex-shrink-0">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
    </svg>;
}
